  import * as moment from 'moment';
  import 'vendor/bootstrap-material-datetimepicker_hacked/js/bootstrap-material-datetimepicker.js';


'use strict';

var ad_dateTimePicker = function () {
  var self = this;

  self.init();
  self.bind();
};

ad_dateTimePicker.prototype.init = function () {
  var self = this;

  // console.log('init ad_dateTimePicker');

  self.date_format = 'DD-MM-YYYY';
  self.time_format = 'HH:mm';
  self.date_time_format = self.date_format + ' ' + self.time_format;

  self.init_date();
  self.init_time();
  self.init_dateTime();
  self.init_dateMinToday();
  self.init_dateRange();

};

ad_dateTimePicker.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_dateTimePicker');

  jQuery(document).arrive('.ad_dateTimePicker.ad_dateTimePicker_date', self.init_date);
  jQuery(document).arrive('.ad_dateTimePicker.ad_dateTimePicker_time', self.init_time);
  jQuery(document).arrive('.ad_dateTimePicker.ad_dateTimePicker_dateTime', self.init_dateTime);
  jQuery(document).arrive('.ad_dateTimePicker.ad_dateTimePicker_dateMinToday', self.init_dateMinToday);
  jQuery(document).arrive('.ad_dateTimePicker.ad_dateTimePicker_dateRange', self.init_dateRange);

};

ad_dateTimePicker.prototype.init_date = function () {
  var self = this;

  jQuery('.ad_dateTimePicker.ad_dateTimePicker_date').each(function (/*index*/) {
    var element = jQuery(this);

    var datePicker = element.find('input');

    if (element.hasClass('st_mounted') === false) {

      datePicker.bootstrapMaterialDatePicker(
        {
          weekStart: 1,
          format: self.date_format,
          time: false
        }
      );

      element.addClass('st_mounted');
    }

  });
};

ad_dateTimePicker.prototype.init_time = function () {
  var self = this;

  jQuery('.ad_dateTimePicker.ad_dateTimePicker_time').each(function (/*index*/) {
    var element = jQuery(this);

    var datePicker = element.find('input');

    if (element.hasClass('st_mounted') === false) {

      datePicker.bootstrapMaterialDatePicker(
        {
          date: false,
          shortTime: false,
          format: self.time_format
        }
      );

      element.addClass('st_mounted');
    }

  });
};



ad_dateTimePicker.prototype.init_dateTime = function () {
  var self = this;

  jQuery('.ad_dateTimePicker.ad_dateTimePicker_dateTime').each(function (/*index*/) {
    var element = jQuery(this);

    var datePicker = element.find('input');

    if (element.hasClass('st_mounted') === false) {

      datePicker.bootstrapMaterialDatePicker(
        {
          format: self.date_time_format,
          weekStart: 1
        }
      );

      element.addClass('st_mounted');
    }

  });
};

ad_dateTimePicker.prototype.init_dateMinToday = function () {
  var self = this;

  jQuery('.ad_dateTimePicker.ad_dateTimePicker_dateMinToday').each(function (/*index*/) {
    var element = jQuery(this);

    var datePicker = element.find('input');

    if (element.hasClass('st_mounted') === false) {

      datePicker.bootstrapMaterialDatePicker(
        {
          format: self.date_format,
          weekStart: 1,
          minDate: new Date()
        }
      );

      element.addClass('st_mounted');
    }

  });
};



ad_dateTimePicker.prototype.init_dateRange = function () {
  var self = this;

  jQuery('.ad_dateTimePicker.ad_dateTimePicker_dateRange').each(function (/*index*/) {
    var element = jQuery(this);

    var start = element.find('.ad_dateTimePicker_el_start');
    var end = element.find('.ad_dateTimePicker_el_end');

    if (element.hasClass('st_mounted') === false) {

      // Init Start Input Field
      start.bootstrapMaterialDatePicker(
        {
          weekStart: 1,
          minDate: new Date(),
          time: false,
          format: self.date_format
        }
      ).on('change', function(e, date) {

          var parent = jQuery(this).closest('.ad_dateTimePicker_dateRange');
          var date_end = parent.find('.ad_dateTimePicker_el_end');

          date_end.bootstrapMaterialDatePicker('setMinDate', date);
        }
      );

      // Init End Input Field
      end.bootstrapMaterialDatePicker(
        {
          weekStart: 1,
          minDate: new Date(),
          time: false,
          format: self.date_format
        }
      );

      element.addClass('st_mounted');
    }

  });
};




jQuery( document ).ready(function() {

  window.ad_dateTimePicker = new ad_dateTimePicker();

});
